import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';
import Home from '@p/home.vue'
import Lotterydetails from "@p/lotterydetails.vue";
import Lotteryrecord from "@p/lotteryrecord.vue";
import Lotterychart from "@p/lotterychart.vue";
import Newslist from "@p/newslist.vue";
import Newsdetail from "@p/newsdetail.vue";


Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      pageAnimationDisable: true,
    },
    component: Home
  },
  {
    path: '/lotterydetails',
    name: 'lotterydetails',
    component: Lotterydetails
  },
  {
    path: '/lotteryrecord',
    name: 'lotteryrecord',
    component: Lotteryrecord
  },
  {
    path: '/lotterychart',
    name: 'lotterychart',
    component: Lotterychart
  },
  {
    path: '/news/list',
    name: 'newslist',
    component: Newslist
  },
  {
    path: '/news/detail',
    name: 'newsdetail',
    component: Newsdetail
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

//需要登录才能进入的路由
const needLoginRoute = [
  '/lotterypurchase',
  '/Wallet',
  '/Walletdetails',
  '/WalletProgress',
  '/Recharge',
  '/Recharge/PayBankInput',
  '/Recharge/PayBankConfirm',
  '/Recharge/PayQrcode',
  '/Recharge/PayQrcodeFinshed',
  '/Recharge/PayOnlineWay',
  '/Transfer',
  '/TransferDsf',
  '/Withdrawal',
  '/PayOrWithdrawal',
  '/RechargeWithdrawalRecord',
  '/lotteryorderhistory',
  '/BillChangeRecord',
  '/BillChangeRecordDetail',
  '/PersonalOrTeamReport',
  '/UserManage',
  '/OpeningAccountCenter',
  '/ProxyCommission',
  '/SafeCenter',
  '/usersetting',
  '/bettingplatform',
  '/lotterycredit',
  '/Redbag',
  '/Sign',
  '/IntegralRecord',
  '/IntegralRecordFilter',
  '/IntegralExchange',
  '/personalinfomation',
  '/ProxyCommission',
  '/im'
]

//需要正常账号才可以进入的路由，试玩账号不允许进入的路由
const needAuthRoute = [
  '/Wallet',
  '/Walletdetails',
  '/WalletProgress',
  '/Recharge',
  '/Recharge/PayBankInput',
  '/Recharge/PayBankConfirm',
  '/Recharge/PayQrcode',
  '/Recharge/PayQrcodeFinshed',
  '/Recharge/PayOnlineWay',
  '/Transfer',
  '/TransferDsf',
  '/Withdrawal',
  '/PayOrWithdrawal',
  '/RechargeWithdrawalRecord',
  '/BillChangeRecord',
  '/BillChangeRecordDetail',
  '/PersonalOrTeamReport',
  '/IntegralExchange',
  '/SafeCenter',
  '/Sign',
  '/Redbag',
  '/IntegralRecord',
  '/IntegralRecordFilter',
  '/OpeningAccountCenter',
  '/UserManage',
  '/personalinfomation',
  '/ProxyCommission',
  '/im'
  // '/Gameloadingpage'
]

//推广账号无法进入的路由
const needTgRoute = [
  '/Transfer',
  '/TransferDsf'
]
//需要清空投注记录的查询参数的路由
const needClearQuery=[
  '/bettingplatform',
  '/lotterypurchase',
  '/lotterycredit'
]

router.beforeEach((to, from, next) => {
  // console.log(`to:${to.path}`);
  // console.log(`from:${from.path}`);

  // const TOKEN = store.state.user.token;
  // const USERINFO = store.state.user.userInfo;
  const TOKEN = "";
  const USERINFO = "";

  if (needLoginRoute.includes(to.path) && !TOKEN) {

    
    next(from.path)
    return;

  } else if (USERINFO.memberType == 3 && needAuthRoute.includes(to.path)) {

    next(from.path)
    return;

  } else if (USERINFO.memberType == 4 && needTgRoute.includes(to.path)) {

    next(from.path)
    return;

  } else if (needClearQuery.includes(from.path)) {

    store.commit("user/clearBetRecordQuery")
    next()
    return;

  } else {

    next()
    return;

  }
})

export default router
